import { render, staticRenderFns } from "./ItemClassGroup.vue?vue&type=template&id=1b0c4806&scoped=true&"
import script from "./ItemClassGroup.vue?vue&type=script&lang=js&"
export * from "./ItemClassGroup.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1b0c4806",
  null
  
)

export default component.exports